import React from 'react'

import PropTypes from 'prop-types'

import { useT } from '@galo-monitor/i18n'
import { bell } from '@galo-monitor/icons'
import { colors } from '@galo-monitor/styles'
import Icon from '@galo-monitor/web-components/Icon'

import IconButton from '../IconButton'

const NotificationsIconButton = ({ iconColor, iconSize, ...props }) => {
  const t = useT()
  return (
    <IconButton tooltip={ t('notification', { howMany: 2 }) } { ...props }>
      <Icon icon={ bell } color={ iconColor } size={ iconSize } />
    </IconButton>
  )
}

NotificationsIconButton.propTypes = {
  iconColor: PropTypes.string,
  iconSize: PropTypes.number
}

NotificationsIconButton.defaultProps = {
  iconColor: colors.mutedText,
  iconSize: undefined
}

export default NotificationsIconButton
